import { render, staticRenderFns } from "./TagList.vue?vue&type=template&id=50280104&scoped=true"
import script from "./TagList.vue?vue&type=script&lang=js"
export * from "./TagList.vue?vue&type=script&lang=js"
import style0 from "./TagList.vue?vue&type=style&index=0&id=50280104&prod&scoped=true&lang=css"
import style1 from "./TagList.vue?vue&type=style&index=1&id=50280104&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50280104",
  null
  
)

export default component.exports